import { ReactElement } from 'react';
import { AdminPermission, Organization } from '@localstack/types';
import { ButtonWithDialog } from '@localstack/ui';
import { v4 as uuid } from 'uuid';
import { Alert } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import { useRoutes, AdminService, useApiEffect } from '@localstack/services';

import { AppRoute } from '~/config';
import { AdminLayout } from '~/layouts';
import { useAuthProvider } from '~/hooks/useAuthProvider';

export const Organizations = (): ReactElement => {
  const { goto } = useRoutes();
  const { can } = useAuthProvider();

  const { createOrganization } = useApiEffect(AdminService, ['createOrganization'], {
    revalidate: ['getOrganization'],
  });

  const handleCreateOrg = async () => {
    const result = await createOrganization({
      id: 'will-be-auto-generated',
      name: uuid(),
      creator: 'REPLACE ME WITH ORG OWNER ID!',
      members: [],
    } as Organization);

    goto(AppRoute.ADMIN_ORGANIZATION, { id: result.id });
  };

  return (
    <AdminLayout
      title="Manage Organizations"
      trailingActions={
        <ButtonWithDialog
          componentType="Button"
          variant="text"
          startIcon={<AddIcon />}
          dialogTitle="Create new Organization?"
          onClick={handleCreateOrg}
          dialogContent={`
            Are you sure you want to create a new Organization?
            You will be able to fill out further details on the next page
          `}
          disabled={!can(AdminPermission.WORKSPACES_WRITE)}
        >
          Create Workspace
        </ButtonWithDialog>
      }
    >
      <Alert severity="info">
        This page no longer shows a list of organizations. You can only create new orgs or search for existing ones.
      </Alert>
    </AdminLayout>
  );
};
